import { ChildPaymentSource } from 'types';
import { settlementTexts } from 'consts/text';

export const childSourceTypeLabels: Record<ChildPaymentSource, string> = {
    [ChildPaymentSource.SETTLEMENT]: settlementTexts.children.source.settlement,
    [ChildPaymentSource.CORRECTION]: settlementTexts.children.source.correction,
    [ChildPaymentSource.ADDITIONAL_COST]: settlementTexts.children.source.additionalCost,
    [ChildPaymentSource.MANUAL]: settlementTexts.children.source.manualCost,
};
